import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { cleanRut, formatRut } from 'rutlib/lib';
import { EntregaEquipoLinkService } from 'src/app/pages/services/entrega-equipo-link.service';
import { TrabajadoresService } from 'src/app/pages/services/trabajadores/trabajadores.service';
import { EntregaEquipoPdfService } from 'src/app/pages/services/PDF-GENERADOR/entrega-equipo/entrega-equipo-pdf.service';
import { EditarMovimientoDialogComponent } from '../editar-movimiento-dialog/editar-movimiento-dialog.component';

// Busca el historial completo de un trabajador por rut, tenga o no equipos activos
// actualmente (a diferencia de "Equipos asignados", que solo lista trabajadores con
// al menos un equipo activo y por lo tanto pierde a los que ya devolvieron todo).
@Component({
  selector: 'app-buscar-historial-trabajador',
  templateUrl: './buscar-historial-trabajador.component.html',
  styleUrls: ['./buscar-historial-trabajador.component.css']
})
export class BuscarHistorialTrabajadorComponent {

  rutBusqueda: string = '';
  trabajadoresCache: any[] = [];
  sugerencias: any[] = [];

  trabajadorSeleccionado: { id: number; nombres: string; apellidos: string; rut: any } | null = null;
  buscando: boolean = false;
  buscado: boolean = false;

  cargandoHistorial: boolean = false;
  historial: any[] = [];

  constructor(
    private entregaEquipoLinkService: EntregaEquipoLinkService,
    private trabajadoresService: TrabajadoresService,
    private entregaEquipoPdfService: EntregaEquipoPdfService,
    private dialog: MatDialog
  ) {
    this.trabajadoresService.TraerTrabajadores().subscribe(res => {
      if (res.success) {
        this.trabajadoresCache = res.data || [];
      }
    });
  }

  // Mismo patrón de sugerencias en vivo que generar-entrega-equipos
  onRutInput(event: Event) {
    const valor = (event.target as HTMLInputElement).value;
    this.rutBusqueda = formatRut(valor);
    this.trabajadorSeleccionado = null;
    this.buscado = false;
    this.historial = [];

    const textoLimpio = cleanRut(valor);
    if (!textoLimpio || textoLimpio.length < 3) {
      this.sugerencias = [];
      return;
    }
    this.sugerencias = this.trabajadoresCache
      .filter((t: any) => t.rut && t.rut.toString().includes(textoLimpio))
      .slice(0, 8);
  }

  seleccionarTrabajador(trabajador: any) {
    this.rutBusqueda = formatRut(trabajador.rut.toString());
    this.sugerencias = [];
    this.trabajadorSeleccionado = { id: trabajador.id, nombres: trabajador.nombres, apellidos: trabajador.apellidos, rut: trabajador.rut };
    this.buscado = true;
    this.cargarHistorial();
  }

  buscarPorRut() {
    if (!this.rutBusqueda || this.rutBusqueda.trim().length === 0) {
      return;
    }
    const rutLimpio = cleanRut(this.rutBusqueda);
    this.buscando = true;
    this.trabajadorSeleccionado = null;
    this.buscado = false;
    this.historial = [];
    this.trabajadoresService.traerTrabajadoRut(rutLimpio).subscribe({
      next: (respuesta) => {
        this.buscando = false;
        this.buscado = true;
        if (respuesta?.success && Array.isArray(respuesta.data) && respuesta.data.length > 0) {
          const t = respuesta.data[respuesta.data.length - 1];
          this.trabajadorSeleccionado = { id: t.id, nombres: t.nombres, apellidos: t.apellidos, rut: t.rut };
          this.cargarHistorial();
        }
      },
      error: () => {
        this.buscando = false;
        this.buscado = true;
      }
    });
  }

  private cargarHistorial() {
    if (!this.trabajadorSeleccionado) return;
    this.cargandoHistorial = true;
    this.entregaEquipoLinkService.listarHistorialPorTrabajador(this.trabajadorSeleccionado.id).subscribe(res => {
      this.cargandoHistorial = false;
      this.historial = res.data || [];
    });
  }

  verPdf(movimiento: any) {
    this.entregaEquipoLinkService.buscarPorMovimiento(movimiento.id).subscribe({
      next: (res) => {
        if (res.success && res.data) {
          this.entregaEquipoPdfService.generarPdf(res.data);
        }
      },
      error: () => { /* el error ya se muestra vía handlerError del service */ }
    });
  }

  abrirEditarMovimiento(movimiento: any) {
    const dialogRef = this.dialog.open(EditarMovimientoDialogComponent, {
      width: '500px',
      data: { movimiento }
    });
    dialogRef.afterClosed().subscribe((cambios) => {
      if (cambios) {
        this.cargarHistorial();
      }
    });
  }

}
